module.exports = __webpack_public_path__ + "img/8f1.b745eb5a.jpg";